export enum ClosuresDialogKeysEnum {
  closuresList = 'closuresList',
  editOrCreateClosure = 'editOrCreateClosure',
}
